import React from 'react';
import PageMeta from '../components/common/PageMeta';
import ContactsForm from '../components/contact/ContactsForm';
import ReviewTwo from '../components/tabs/ReviewTabTwo';
import FooterSocial from '../layout/Footer/FooterSocial';
import Navbar from '../layout/Header/Navbar';
import Layout from '../layout/Layout';
import { useLanguage } from '../context/LanguageContext';
import FooterOne from '../layout/Footer/FooterOne';

const RequestDemo = () => {
  const { t } = useLanguage();

  return (
    <Layout>
      <PageMeta title={t('requestDemo.title')} />
      <Navbar posAbsolute />
      <section
        className='sign-up-in-section bg-white ptb-120'
        style={{
          background:
            "url('assets/img/page-header-bg.svg')no-repeat bottom right",
        }}
      >
        <div className='container'>
          <div className='row align-items-center justify-content-between'>
            <ContactsForm />
            <ReviewTwo reqPage/>
          </div>
        </div>
      </section>
      <FooterOne
          style={{
            background:
              "url('assets/img/page-header-bg.svg')no-repeat bottom left",
          }}
        />
    </Layout>
  );
};

export default RequestDemo;
